/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailedPspNotificationDto
 */
export interface FailedPspNotificationDto {
    /**
     * 
     * @type {number}
     * @memberof FailedPspNotificationDto
     */
    pspNotificationId: number;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    payload?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    latestFailureReason?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    stackTrace?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FailedPspNotificationDto
     */
    retryCount: number;
    /**
     * 
     * @type {Date}
     * @memberof FailedPspNotificationDto
     */
    pspNotificationTimestamp: Date;
    /**
     * 
     * @type {Date}
     * @memberof FailedPspNotificationDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof FailedPspNotificationDto
     */
    updated: Date;
}

/**
 * Check if a given object implements the FailedPspNotificationDto interface.
 */
export function instanceOfFailedPspNotificationDto(value: object): value is FailedPspNotificationDto {
    if (!('pspNotificationId' in value) || value['pspNotificationId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('retryCount' in value) || value['retryCount'] === undefined) return false;
    if (!('pspNotificationTimestamp' in value) || value['pspNotificationTimestamp'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function FailedPspNotificationDtoFromJSON(json: any): FailedPspNotificationDto {
    return FailedPspNotificationDtoFromJSONTyped(json, false);
}

export function FailedPspNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailedPspNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pspNotificationId': json['pspNotificationId'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'latestFailureReason': json['latestFailureReason'] == null ? undefined : json['latestFailureReason'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'type': json['type'],
        'retryCount': json['retryCount'],
        'pspNotificationTimestamp': (new Date(json['pspNotificationTimestamp'])),
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function FailedPspNotificationDtoToJSON(json: any): FailedPspNotificationDto {
    return FailedPspNotificationDtoToJSONTyped(json, false);
}

export function FailedPspNotificationDtoToJSONTyped(value?: FailedPspNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pspNotificationId': value['pspNotificationId'],
        'payload': value['payload'],
        'latestFailureReason': value['latestFailureReason'],
        'stackTrace': value['stackTrace'],
        'type': value['type'],
        'retryCount': value['retryCount'],
        'pspNotificationTimestamp': value['pspNotificationTimestamp'].toISOString(),
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
    };
}

